import React, { useEffect, useState } from "react";
import "./discounted-products.scss";

interface MyProps {
  title: string;
  products: any[];
}

const DiscountedProducts: React.FC<MyProps> = ({ title, products }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const productsPerPage = 3;

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkIsMobile);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  const totalPages = Math.ceil(products.length / productsPerPage);

  const start = activeIndex * productsPerPage;
  const end = start + productsPerPage;
  const visibleProducts = isMobile ? products : products.slice(start, end);

  return (
    <div className="discount-product-container">
      <div className={`layout ${isMobile ? "mobile" : ""}`}>
        <div className="title-container">
          <h2 className="title">{title}</h2>
          <button>Бүгдийг үзэх</button>
        </div>

        <div className={`product-container ${isMobile ? "mobile" : ""}`}>
          {visibleProducts.map((el, i) => (
            <div key={i} className="product">
              {el}
            </div>
          ))}
        </div>
      </div>

      {!isMobile && (
        <div className="button-container">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`dot-btn ${activeIndex === index ? "active" : ""}`}
            >
              <span className="dot" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DiscountedProducts;
